
import { mapState } from "vuex";
import currencyConverter from "../common/currency-converter.vue";

export default {
  components: { currencyConverter },
  props: {
    printMode: {
      default: false
    },
    titles: {
      type: Array,
      default: () => []
    },
    totalObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      channel: "total",
      aggregatorDiscount: false,
      total: {
        id: "total",
        name: "total",
        label: "Total"
      }
    };
  },

  computed: {
    ...mapState("report", ["summary"]),
    channels() {
      const channelsList = this.$constants.Channels.CHANNELS.filter(
        (channel) => {
          if (
            this.summary.filter((ch) => ch.channel === channel.name).length > 0
          ) {
            return channel;
          }
        }
      );
      channelsList.push(this.total);
      return channelsList;
    },
    selectedSummary() {
      if (this.channel === this.total.name) {
        return this.totalObj;
      } else {
        return this.summary.find((s) => s.channel === this.channel);
      }
    },
    titlesList() {
      if (this.aggregatorDiscount) {
        return this.titles.filter((title) => title.value !== "channel");
      } else {
        return this.titles.filter(
          (title) => title.value !== "channel" && title.value !== "aggrDiscount"
        );
      }
    }
  }
};
